import { MentionSourceApiTypesEnum } from '../../../api/mentions/enum/mention-source-api-types.enum';

export enum SeriesTypeEnum {
    folder = 'folder',
    topic = 'topic',
    tag = 'tag',
    tagGroup = 'tagGroup',
    sourceGroup = 'sourceGroup',
    subscription = 'subscription',
    googleAnalytics = 'googleAnalytics',
    theme = 'theme',
    socialTopic = 'socialTopic',
    aiAgent = 'aiAgent'
}

export const mentionSeriesTypes = [
    SeriesTypeEnum.folder,
    SeriesTypeEnum.topic,
    SeriesTypeEnum.tag,
    SeriesTypeEnum.tagGroup,
    SeriesTypeEnum.sourceGroup,
    SeriesTypeEnum.subscription,
    SeriesTypeEnum.aiAgent
];

export const socialSeriesTypes = [
    SeriesTypeEnum.theme,
    SeriesTypeEnum.socialTopic,
];

export const externalDataSeriesTypes = [
    SeriesTypeEnum.googleAnalytics
];

export enum SeriesSourceTypesEnum {
    topic = 'topic',
    folder = 'folder',
    tag = 'tag',
    tagGroup = 'tagGroup',
    sourceGroup = 'sourceGroup',
    subscription = 'subscripiton',
    theme = 'theme',
    agent = 'agent',
    aiAgent = 'aiAgent'
};

export const seriesSourceTypesToSeriesTypesMap: Map<SeriesSourceTypesEnum, SeriesTypeEnum> = new Map<SeriesSourceTypesEnum, SeriesTypeEnum>([
    [ SeriesSourceTypesEnum.topic, SeriesTypeEnum.topic ],
    [ SeriesSourceTypesEnum.folder, SeriesTypeEnum.folder ],
    [ SeriesSourceTypesEnum.tag, SeriesTypeEnum.tag ],
    [ SeriesSourceTypesEnum.tagGroup, SeriesTypeEnum.tagGroup ],
    [ SeriesSourceTypesEnum.sourceGroup, SeriesTypeEnum.sourceGroup ],
    [ SeriesSourceTypesEnum.subscription, SeriesTypeEnum.subscription ],
    [ SeriesSourceTypesEnum.theme, SeriesTypeEnum.theme ],
    [ SeriesSourceTypesEnum.agent, SeriesTypeEnum.socialTopic ],
    [ SeriesSourceTypesEnum.aiAgent, SeriesTypeEnum.aiAgent ]
]);

export const seriesTypesToSeriesSourceTypesMap: Map<SeriesTypeEnum, SeriesSourceTypesEnum> = new Map<SeriesTypeEnum, SeriesSourceTypesEnum>([
    [ SeriesTypeEnum.topic, SeriesSourceTypesEnum.topic ],
    [ SeriesTypeEnum.folder, SeriesSourceTypesEnum.folder ],
    [ SeriesTypeEnum.tag, SeriesSourceTypesEnum.tag ],
    [ SeriesTypeEnum.tagGroup, SeriesSourceTypesEnum.tagGroup ],
    [ SeriesTypeEnum.sourceGroup, SeriesSourceTypesEnum.sourceGroup ],
    [ SeriesTypeEnum.subscription, SeriesSourceTypesEnum.subscription ],
    [ SeriesTypeEnum.theme, SeriesSourceTypesEnum.theme ],
    [ SeriesTypeEnum.socialTopic, SeriesSourceTypesEnum.agent ],
    [ SeriesTypeEnum.aiAgent, SeriesSourceTypesEnum.aiAgent ]
]);

export const mentionSourceApiTypesEnumToSeriesSourceTypesEnum: Map<MentionSourceApiTypesEnum, SeriesSourceTypesEnum> = new Map([
    [MentionSourceApiTypesEnum.TOPIC, SeriesSourceTypesEnum.topic],
    [MentionSourceApiTypesEnum.SUBSCRIPTION, SeriesSourceTypesEnum.subscription],
    [MentionSourceApiTypesEnum.FOLDER, SeriesSourceTypesEnum.folder],
    [MentionSourceApiTypesEnum.SOURCE_GROUP, SeriesSourceTypesEnum.sourceGroup],
    [MentionSourceApiTypesEnum.AGENT, SeriesSourceTypesEnum.agent],
    [MentionSourceApiTypesEnum.THEME, SeriesSourceTypesEnum.theme],
    [MentionSourceApiTypesEnum.TAG, SeriesSourceTypesEnum.tag],
    [MentionSourceApiTypesEnum.TAG_GROUP, SeriesSourceTypesEnum.tagGroup],
    [MentionSourceApiTypesEnum.AI_AGENT, SeriesSourceTypesEnum.aiAgent]
]);

export const seriesSourceTypesEnumToMentionSourceApiTypesEnum: Map<SeriesSourceTypesEnum, MentionSourceApiTypesEnum> = new Map([
    [SeriesSourceTypesEnum.topic, MentionSourceApiTypesEnum.TOPIC],
    [SeriesSourceTypesEnum.subscription, MentionSourceApiTypesEnum.SUBSCRIPTION],
    [SeriesSourceTypesEnum.folder, MentionSourceApiTypesEnum.FOLDER],
    [SeriesSourceTypesEnum.sourceGroup, MentionSourceApiTypesEnum.SOURCE_GROUP],
    [SeriesSourceTypesEnum.agent, MentionSourceApiTypesEnum.AGENT],
    [SeriesSourceTypesEnum.theme, MentionSourceApiTypesEnum.THEME],
    [SeriesSourceTypesEnum.tag, MentionSourceApiTypesEnum.TAG],
    [SeriesSourceTypesEnum.tagGroup, MentionSourceApiTypesEnum.TAG_GROUP],
    [SeriesSourceTypesEnum.aiAgent, MentionSourceApiTypesEnum.AI_AGENT]
]);
